module.exports = __webpack_public_path__ + "media/use_cases/slider-portrait-3-60bf15d8.png";